<template>
  <div>
    <div class="text-xs-right">
      <div>
        <v-layout row wrap class="pa-0 ma-0">
          <v-flex xs12>
            <v-btn depressed color="primary" @click="addStore">ADD</v-btn>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-pagination
      v-model="pageNumber"
      :total-visible="15"
      :length="pagelength"
      @input="changePage"
    ></v-pagination>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      hide-actions
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template #items="props">
        <tr>
          <td>
            {{ props.item.code }}
          </td>
          <td>
            {{ props.item.name }}
          </td>
          <td>
            {{ props.item.address }}
          </td>
          <td class="text-xs-right">
            <v-btn icon @click="editStore(props.item)"> <v-icon>edit</v-icon></v-btn>
            <v-btn icon @click="deleteStore(props.item)"> <v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div>
      <v-dialog v-model="showEdit" persistent width="550px">
        <v-card v-if="showEdit">
          <ToaMegaPaintBranchEdit
            :edittype="edittype"
            :editdata="editdata"
            @onsave="onsave"
            @close="showEdit = false"
          ></ToaMegaPaintBranchEdit>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import ToaMegaPaintBranchEdit from './ToaMegaPaintBranchEdit.vue'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  components: {
    ToaMegaPaintBranchEdit
  },
  data() {
    return {
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'id' },
      columnName: '',
      items: [],

      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'รหัสสาขา', value: 'code' },
        { text: 'ชื่อสาขา', value: 'name' },
        { text: 'สถานที่', value: 'address' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getStore()
  },
  methods: {
    deleteStore(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then(async (result) => {
          if (result.value) {
            this.loading = true
            const data = {
              id: item.id,
              page_id: this.selectedBot.pageid
            }
            try {
              await toaMegapaintApi.deleteMegaPaintBranch(data)
              this.getStore()
              this.$swal.fire({
                type: 'success',
                text: 'สำเร็จ'
              })
            } catch (error) {
              console.error(error)
            } finally {
              this.loading = false
            }
          }
        })
    },
    onsearch() {
      this.getStore()
      this.showsearch = false
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getStore()
      }
    },
    editStore(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getStore()
    },
    addStore() {
      this.edittype = 'create'
      this.showEdit = true
    },
    async getStore() {
      try {
        var data = {
          page_id: this.selectedBot.pageid,
          limit: this.limit,
          offset: this.offset
        }
        this.loading = true
        let response = await toaMegapaintApi.getMegaPaintBranch(data)
        if (response.data.data) {
          this.items = response.data.data
          this.total = response.data.total
        } else {
          this.items = []
          this.total = 0
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/ToaMegaPaintBranch.vue